import React, { useState } from "react";
import LiveAuctionCarDetail from "../components/LiveAuction/LiveAuctionCarDetaill";
import LiveAuctionCarsList from "../components/LiveAuction/LiveAuctionCarsList";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../../utils/constants/routes";
// import CarsInNegotiationDetails from "../components/CarsInNegotiation/LiveAuction/CarsInNegotiationDetails";
import CarsInNegotiationDetailsSeller from "@common/pages/Dashboard/components/CarsInNegotiation/LiveAuction/CarsInNegotiationDetailsSeller";
import CarsInNegotationList from "../components/CarsInNegotiation/CarsInNegotiationList";
import { auctionTypes } from "@common/utils/constants/auction";
import CarsInNegotiationDetailsBuyNow from "../components/CarsInNegotiation/BuyNow/CarsInNegotiationDetailsBuyNow";

const CarsInNegotiation = () => {

  // useNavigate...
  const navigate = useNavigate();
  // useNavigate...

  // useLocation...
  const location = useLocation();
  // useLocation...

  const Vehicle_Id = location?.pathname?.split?.(`${routes.carsInNegotiation}/`)?.[1] ||
    location?.pathname?.split?.(`${routes.carsInNegotiationBuyNow}/`)?.[1];

  // useState variables start...
  const [detailView, setDetailView] = useState(false);
  const [selectedCar, setSelectedCar] = React.useState(null);
  // useState variables end...

  if (Vehicle_Id) {
    return <CarsInNegotiationDetailsSeller 
      selectedCar={selectedCar}
      setSelectedCar={setSelectedCar}
    />;
  }
  return <CarsInNegotationList 
    selectedCar={selectedCar}
    setSelectedCar={setSelectedCar}
    onCarClick={(car) => {
      setSelectedCar(car);
      setDetailView(true);
      navigate(`${routes.dashboardNavigation}${
        location?.pathname?.includes(routes.carsInNegotiationBuyNow) ? routes.carsInNegotiationBuyNow : routes.carsInNegotiation
      }/${car?.Vehicle_Id}`);
    }}
  />;
};

export default CarsInNegotiation;
